import { Form, Modal } from "antd";
import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/button/saveButton";
import BaseInput from "../../../components/form/BaseInput";
import {
  editConfigurationalServiceRequest,
  getConfigurationalServiceListRequest,
} from "../../../redux/systemConfigurationSlice";
import { BannerImage, STATUSES } from "../../../config/constants/defaultValues";
import { useDispatch } from "react-redux";
import BannerImageCard from "../../../components/shared/bannerImageCard";
import TextAreas from "../../../components/form/TextAreas";

const ServiceEditModal = ({ isModalOpen, setIsModalOpen, modalData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [serviceImageUrl, setServiceImageUrl] = useState();
  const [serviceImageFile, setServiceImageFile] = useState();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (modalData) {
      form.setFieldsValue({
        title: modalData?.title,
        description: modalData?.description,
      });
      setServiceImageUrl(modalData?.service_image ?? BannerImage);
    }
  }, [modalData]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //Save Button
  const onSave = async (formData) => {
    var values = {
      ...formData,
      service_image: serviceImageFile ?? "",
      service_id: modalData?.id,
      status: "1",
      _method: "PUT",
    };
    setIsLoading(true);
    await dispatch(
      editConfigurationalServiceRequest({
        values,
      })
    ).then((data) => {
      if (data.payload.status === 200) {
        dispatch(getConfigurationalServiceListRequest({}));
        setIsModalOpen(false);
      }
      setIsLoading(false);
    });
  };
  return (
    <>
      <Modal
        className="modal-styles"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        centered={true}
        title={false}
      >
        <div className="row">
          <div className="col-md-12">
            <h5 className="table-heading mb-0 ">Edit Service</h5>
          </div>
        </div>
        <div className="modal-content">
          <Form
            layout="vertical"
            className="pt-3"
            onFinish={onSave}
            form={form}
          >
            <div className="row">
              <div className="col-sm-12 d-flex justify-content-between align-items-start">
                <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12">
                  <BaseInput
                    inputIcon={<i className="bi bi-pencil icon_style"></i>}
                    labelText="Service Title"
                    name="title"
                    placeText="Add Service Title"
                  />
                </div>
                <SaveButton
                  loading={isLoading ? STATUSES.LOADING : false}
                  title="Save"
                />
              </div>
            </div>

            <div class="row">
              <div className="col-xl-10 col-lg-12 col-md-12 col-sm-12">
                <BannerImageCard
                  title="Service Image"
                  imageUrl={serviceImageUrl ?? BannerImage}
                  isBlogImage={true}
                  setImageFile={setServiceImageFile}
                  setImageUrl={setServiceImageUrl}
                  imageText="Change Image"
                />
              </div>
              <div className="col-xl-10 col-lg-12 col-md-12 col-sm-12"></div>
              <div className="col-xl-10 col-lg-12 col-md-12 col-sm-12">
                <TextAreas
                  labelText="Description"
                  name="description"
                  placeText="Description"
                />
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  );
};
export default ServiceEditModal;
